import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/admin/bug/$bugId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/admin/tickets/$id",
      params: {
        id: params.bugId,
      },
    });
  },
});
